import PopupDialog from 'components/dialog/PopupDialog';
import ButtonCol from 'components/form-elements/ButtonCol';
import DropUpload from 'components/form-elements/DropUpload';
import DateView from 'components/formatter/DateView';
import DropdownView from 'components/formatter/DropdownView';
import Card from 'components/ui-elements/Card';
import Row from 'components/ui-elements/Row';
import { useAuth } from 'context/AuthProvider';
import { MyConst } from 'data/MyConst';
import useAxiosFunction from 'hooks/useAxiosFunction';
import React, { Fragment, useCallback, useEffect, useState } from 'react'
import { getAge, getStrDateLong, money, getStrDateTimeShort } from 'utils/MyUtils';
import DataList from './DataList';

const DataDetail = (props) => {
    const { url, reload = 0, use_card = true, coltype, cellid, editid, columns, title, defaultValue, id_detail, data, children, renderContent, ...rest } = props
    const [detailRes, errd, loadingd, axiosFetch] = useAxiosFunction()

    const canFetch = Boolean(url) && Boolean(id_detail) && !data
    const detail = data ? { data } : detailRes

    const refetchd = useCallback(async () => {
        if (!canFetch) return null
        return await axiosFetch({ url: url + "/" + id_detail, auth: true })
    }, [axiosFetch, canFetch, id_detail, url])

    const itemDataView = (label, data, size = 4, idx = 0) => {
        return <div key={idx} className={"col-md-" + size + " mb-0 mt-2"}>
            <strong>{label}</strong>
            <p className="text-muted mb-1">{data ? data : "-"}</p>
            <hr style={{ margin: 0 }} />
        </div>
    }

    const itemDivider = (label, idx = 0) => (
        <div key={idx} className="col-md-12 mb-1 mt-3">
            {label && <strong>{label}</strong>}
            <hr style={{ marginTop: 6, marginBottom: 0 }} />
        </div>
    )

    const itemPhotoView = (label, filename, location = "profile", size = 4, idx = 0) => {
        const src = filename ? `${MyConst.URLASET}/${location}/${filename}` : ""
        return <div key={idx} className={"col-md-" + size + " mb-0 mt-2"}>
            <strong>{label}</strong>
            <div className="text-muted mb-1">
                {src ? (
                    <a href={src} target="_blank" rel="noreferrer">
                        <img
                            alt={label}
                            src={src}
                            style={{
                                display: "block",
                                width: 96,
                                height: 96,
                                objectFit: "cover",
                                borderRadius: 6,
                                border: "1px solid #ddd",
                                background: "#fff",
                            }}
                        />
                    </a>
                ) : "-"}
            </div>
            <hr style={{ margin: 0 }} />
        </div>
    }

    useEffect(() => {
        refetchd()
    }, [refetchd, reload])



    //const tgl = peserta?.data?.tgl_lahir ? getStrDateLong(peserta?.data?.tgl_lahir) : ""
    //const tbiaya = biaya?.data?.total_biaya ? money(biaya?.data?.total_biaya + "") : ""
    //const age = peserta?.data?.tgl_lahir ? getAge(peserta?.data?.tgl_lahir, new Date()) : ""
    const customContent = id_detail && detail?.data && renderContent
        ? renderContent(detail.data, { coltype, title })
        : null

    const content = id_detail && detail && <>
        <Row>
            <div className={"col-md-12 mb-0 mt-2"}>
                <Row>

                    {columns && columns.map((elname, idx) => {
                        const element = coltype?.[elname]

                        let { type, value, label, name, validation, options, colsize, caption = "", captionFalse = "", viewsize, valueId, labelId, ...rest } = element
                        name = name ? name : elname
                        const colsz = colsize ? colsize : "3"
                        let ret = ""
                        const renderFunc = element?.renderFunc

                        let val = detail?.data?.[name]
                        const colname = name
                        const item = detail?.data

                        if (renderFunc) {
                            val = renderFunc(val, colname, item, coltype)
                        }

                        switch (element?.type) {
                            case "divider":
                                ret = itemDivider(label, idx)
                                break;
                            case "text":
                            case "email":
                            case "number":
                            case "textarea":
                            case "dropdowndinamis":
                                ret = itemDataView(label, val, viewsize ? viewsize : colsz, idx)
                                break;
                            case "photodrop":
                                ret = itemPhotoView(label, val, element?.data?.location, viewsize ? viewsize : colsz, idx)
                                break;
                            case "password":
                                ret = itemDataView(label, "******", viewsize ? viewsize : colsz, idx)
                                break;
                            case "dropdown":
                                ret = itemDataView(label, <DropdownView detail={item} {...element} />, viewsize ? viewsize : colsz, idx)
                                break;
                            case "date":
                                ret = itemDataView(label, val ? <DateView val={val} /> : "-", viewsize ? viewsize : colsz, idx)
                                break;
                            case "datetime":
                                ret = itemDataView(label, getStrDateTimeShort(val), viewsize ? viewsize : colsz, idx)
                                break;
                            case "money":
                                ret = itemDataView(label, money(val), viewsize ? viewsize : colsz, idx)
                                break;
                            case "checkbox":
                                if (!renderFunc) {
                                    val = val ? caption : captionFalse
                                }
                                ret = itemDataView(label, val, viewsize ? viewsize : colsz, idx)
                                break;
                            case "checkboxform":
                                if (!renderFunc) {
                                    val = val ? caption : captionFalse
                                }
                                ret = itemDataView(label, val, viewsize ? viewsize : colsz, idx)
                                break;
                            case "inputdetail":
                                const { viewdatalist, ...rest } = element
                                const detcfg = { ...viewdatalist }
                                detcfg["title"] = detcfg?.title ? detcfg.title : label
                                detcfg["coltype"] = detcfg?.coltype ? detcfg.coltype : coltype
                                const url = detcfg?.dlist?.urldetail + "/" + id_detail
                                detcfg["dlist"]["url"] = url

                                //detcfg["delconfig"] = detcfg?.delconfig ? detcfg.delconfig : false
                                if (detcfg?.addconfig) {
                                    detcfg["coltype"][cellid] = { type: "hidden", name: cellid, value: id_detail }
                                    const columnnew = [cellid, ...detcfg["addconfig"]["columns"]]
                                    detcfg["addconfig"]["columns"] = columnnew
                                }

                                ret = <div key={idx} className={"col-md-12 mb-0 mt-2"} >
                                    <br />&nbsp;<strong>{detcfg["title"]}</strong><br />&nbsp;
                                    <DataList {...detcfg} />
                                </div>
                                break;
                            default:
                                if (label) {
                                    ret = itemDataView(label, val, viewsize ? viewsize : colsz, idx)
                                }
                                break;
                        }
                        return element && ret
                    })}
                </Row>
            </div>

        </Row >
        {children && <Row>
            <div className={"col-md-12 mb-0 mt-2"}>
                {children}
            </div>
        </Row>}
    </>

    return (
        <Fragment>

            {id_detail && detail && <>
                {customContent ? customContent : use_card && <Card title={title}>
                    {content}
                </Card>}
                {!customContent && !use_card && <>{content}</>}

            </>}
        </Fragment >
    )
}

export default DataDetail
